import classNames from "classnames";
import React from "react";
import styles from "./widgetCheckboxInput.css";

export type ColorSchema = "primary" | "secondary-orange";

interface Props {
  id: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  colorSchema?: ColorSchema;
  radioStyle?: boolean;
  className?: string;
  disabled?: boolean;
}

export const WidgetCheckboxInput = ({
  id,
  label,
  checked,
  onChange,
  className,
  radioStyle,
  disabled = false,
  colorSchema = "secondary-orange"
}: Props) => {
  const colorStyle =
    colorSchema === "primary" ? styles["color-primary"] : styles["color-secondary"];

  return (
    <div
      className={classNames(styles.wrapper, colorStyle, className, {
        [styles["primary-disabled"]]: disabled
      })}
    >
      <label htmlFor={id}>
        <input
          disabled={disabled}
          id={id}
          type={"checkbox"}
          checked={checked}
          onChange={(ev) => onChange(ev.target.checked)}
        />
        <div
          className={classNames(styles.box, {
            [styles.round]: radioStyle,
            [styles["non-radio"]]: !radioStyle
          })}
        >
          <span>
            {radioStyle ? (
              <i className={styles["radio-circle-active"]} />
            ) : (
              <i className="icon-ok" />
            )}
          </span>
        </div>
        {label && <span className={styles.label}>{label}</span>}
      </label>
    </div>
  );
};
